import React from 'react';
import { Slice } from 'gatsby';

export const BlogFeed = () => <Slice alias="blogFeed" allowEmpty />;
